/**
 * MIT License
 *
 * Copyright (c) 2023 Jamasp Team <mailto:radmanesh@gmail.com Arman Radmanesh> <mailto:salarirad@gmail.com Salar Rad>
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import { Alert, Box, Container} from '@mui/material';
import { Outlet } from 'react-router-dom';
import { useAlert } from '../context/AlertContext';

const BareLayout = () => {
  const { alerts } = useAlert();


  return (
    <Box sx={(theme) => ({
      backgroundColor: theme.palette.background.default,
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      width: '100%'
    })}>
      <Container maxWidth="xl" sx={{ flexGrow: 1, width: '100%' , px: "0px!important"}}>
        <Box display="flex" flexDirection="column" minHeight="100vh" sx={(theme) => ({
          backgroundColor: theme.palette.background.default,
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
        })}>
          <Container maxWidth="xl" sx={{ flexGrow: 1 , pl: '0px!important', pr: '0px!important'}}>
            {alerts.map((alert, index) => (
              <Alert key={index} severity={alert.type}>
                {alert.message}
              </Alert>
            ))}
            <Outlet />
          </Container>

        </Box>
      </Container>
    </Box>
  );
};

export default BareLayout;
